import { lookupTablesData } from 'consts'
import { Form, Row, Col } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import LookupTableProps from 'types/lookupTableProps'
import Select from 'react-select'
import { selectClassNames } from 'shared/assets/conf'

interface LookupTableFilterProps {
  appUrl: string
}
const LookupTableFilter: React.FunctionComponent<LookupTableFilterProps> = ({
  appUrl,
}: LookupTableFilterProps) => {
  const navigate = useNavigate()

  const lookupTables: Array<LookupTableProps> = lookupTablesData
  const selectedTableIndex: number = lookupTables.findIndex((row) => row.appUrl === appUrl)

  const onInputChange = (data) => {
    navigate('/' + data)
  }

  return (
    <Form.Group className='form-group inline-space-r'>
      <Select
        name='table'
        className='light lookup-table-input'
        classNames={selectClassNames}
        options={lookupTables}
        defaultValue={lookupTables[selectedTableIndex]}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.appUrl}
        isClearable={false}
        onChange={(value) => onInputChange(value?.appUrl)}
      />
    </Form.Group>
  )
}

export default LookupTableFilter
